const initialState = {
  isLoading: false,
};

const LoadingReducer = (state = initialState, action) => {
  if (action.type === 'LOADER') {
    return {
      ...state,
      isLoading: action.data.isLoading,
    };
  }
  return state;
};

export default LoadingReducer;
